import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import App from './App';
import { Login } from '../pages/Login/Login';
import Registration from '../pages/Registration last/Registration';
// import { Error } from '../pages/Error';
// import { NotFound } from '../pages/NotFound';
// import { Access } from '../pages/Access';
import { AuthProvider } from '../context/AuthContext'
import PrivateAppWrapper from '../Routes/PrivateAppWrapper'
import PublicAppWrapper from '../Routes/PublicAppWrapper'


const AppWrapper = () => {
    let location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    return (
        <AuthProvider>
            <Routes>
                <Route exact path="/login" element={
                    <PublicAppWrapper>
                        <Login />
                    </PublicAppWrapper>
                    } 
                />
                {/* <Route exact path="/registration" element={
                    <PublicAppWrapper>
                        <Registration />
                    </PublicAppWrapper>
                    } 
                /> */}

                <Route exact path="*" element={
                    <PrivateAppWrapper>
                        <App />
                    </PrivateAppWrapper>
                    } 
                />

                {/* no need now */}
                {/* <Route exact path='/notfound' element={<NotFound />} />
                <Route exact path='/access' element={<Access />} />
                <Route exact path='/error' element={<Error />} />
                <Route exact path='/notfound' element={<NotFound />} /> */}

            </Routes>
        </AuthProvider>
    );
};

export default AppWrapper;